import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@shared/components/ui/hover-card';

/**
 * Inline "Needs review" marker for a modal field flagged by the review
 * pipeline. Mirrors the table's NeedsReviewPopover styling (warning icon +
 * hover explanation), minus its review-page link — the user is already
 * reviewing.
 */
export function NeedsReviewBadge({ message }: { message: string }) {
  return (
    <HoverCard openDelay={150} closeDelay={150}>
      <HoverCardTrigger asChild>
        <span className="flex items-center gap-1">
          <Icons.warning className="size-4 shrink-0 text-warning-600" />
          <Text
            variant="subtle"
            className="text-xs font-medium text-warning-600"
          >
            Needs review
          </Text>
        </span>
      </HoverCardTrigger>
      <HoverCardContent className="w-80">
        <Text variant="subtle">{message}</Text>
      </HoverCardContent>
    </HoverCard>
  );
}
